import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { WithNotFound } from '../errors';
import { Routes as ClientRoutes } from './clients';
import { Routes as UserRoutes } from './users';
import { Routes as HooksRoutes } from './hooks';
import { Routes as AccountRoutes } from './account';
import { Routes as PaymentProfileRoutes } from './paymentProfiles';
import { Routes as PaymentConnectionRoutes } from './paymentConnections';
import { Routes as PayoutRulesRoutes } from './payoutRules';
import { Routes as LocationsRoutes } from './locations';
import { Routes as ReportConfigRoutes } from './reports';
import { Routes as SettlementReportsRoutes } from './settlementReports';
import { Routes as ThirdPartyIntegrationsRoutes } from './thirdParty';
import PayoutDestinationRoutes from './payoutDestinations/Routes';

const SettingsRoutes = () => (
    <WithNotFound>
        <Route
            exact
            path="/:accountId/settings"
            render={(props) => <Redirect to={`/${props.match.params.accountId}/settings/account`} />}
        />
        {UserRoutes}
        {ClientRoutes}
        {HooksRoutes}
        {AccountRoutes}
        {PaymentProfileRoutes}
        {PaymentConnectionRoutes}
        {PayoutRulesRoutes}
        {PayoutDestinationRoutes}
        {LocationsRoutes}
        {ReportConfigRoutes}
        {SettlementReportsRoutes}
        {ThirdPartyIntegrationsRoutes}
    </WithNotFound>
);

export default SettingsRoutes;
